import React, { useState } from 'react';

import cn from 'classnames';
import { Link } from 'gatsby';

import { externalLink } from '../util';

import BurgerIcon from '../components/icons/Burger';
import IssueIndex from '../components/IssueIndex';
import Wrapper from './Wrapper';
import Button from './Button';
import Text from './Text';
import RefraccionesLogo from './logos/refracciones';
import BtgLogo from './logos/btg';
import EyeAnimated from './EyeAnimated';
import AboutOverlay from './AboutOverlay';

import * as styles from './Header.module.css';
import { useIssueIndex } from '../util/queries/issueIndex';

const Header = ({ initialShowAbout, banner, aboutText }) => {
  const issues = useIssueIndex();

  const [showIndex, setShowIndex] = useState();
  const [showAbout, setShowAbout] = useState();

  return (
    <>
      <Wrapper tag="header" className={cn(styles.root)}>
        <AboutOverlay
          isOpen={showAbout}
          setShow={setShowAbout}
          initialShow={initialShowAbout}
          text={aboutText}
        />

        <Link to="/" className={cn(styles.refraccionesLogo)}>
          <RefraccionesLogo />
        </Link>
        <EyeAnimated
          className={cn(styles.eyeIcon)}
          onClick={() => setShowAbout(true)}
        />
        <nav className={cn(styles.nav)}>
          <Button onClick={() => setShowIndex(s => !s)} label="Index" />
        </nav>
        <button
          onClick={() => setShowIndex(s => !s)}
          className={cn(styles.burgerMenu)}
          aria-label="Open Menu"
        >
          <BurgerIcon aria-hidden className={cn(styles.burgerIcon)} />
        </button>

        <a
          className={styles.btgLogo}
          href="https://btgpactual.cl/"
          {...externalLink}
        >
          <BtgLogo className={cn(styles.btgLogo)} />
        </a>
      </Wrapper>

      <IssueIndex
        isShowing={showIndex}
        issues={issues}
        onClose={() => setShowIndex(false)}
      >
        <div className={styles.aboutMobile}>
          <div className={styles.aboutMobileNav}>
            <RefraccionesLogo className={cn(styles.refraccionesLogo)} />

            <button
              onClick={() => setShowIndex(false)}
              className={cn(styles.burgerMenu)}
              aria-label="Close Menu"
            >
              <BurgerIcon aria-hidden className={cn(styles.burgerIcon)} />
            </button>

            <BtgLogo className={cn(styles.btgLogo)} />
          </div>
          <Text text={aboutText} />
        </div>
      </IssueIndex>
    </>
  );
};

export default Header;
